import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'
import { getQueryParams } from 'utils/getQueryParams'
import {
  ALLOCATION_TEMPLATE_LIST_QUERY_KEY,
  ALLOCATION_TEMPLATE_LIST_URL
} from './queryConstants'

type UseAllocationTemplateReturn = {
  templateRotas: any
  isLoading: boolean
}

const useAllocationTemplateList = (): UseAllocationTemplateReturn => {
  const params = getQueryParams({
    isTemplate: true
  })

  const { data, isLoading } = useQuery(
    [ALLOCATION_TEMPLATE_LIST_QUERY_KEY],
    () =>
      getJSON({
        url: `${ALLOCATION_TEMPLATE_LIST_URL}?${params}`,
        isRota: true
      })
  )

  return {
    templateRotas: data || [],
    isLoading
  }
}

export default useAllocationTemplateList
